import React from 'react'
import Popup from '../Component/Popup'
import Header from '../Component/Header'
import HomeSlider from '../Component/HomeSlider'
import TopperXII from '../Component/TopperXII'
import TopperX from '../Component/TopperX'
import RecentActivity from '../Component/RecentActivity'

import Birthday from '../Component/Birthday'
import Events from '../Component/Events'
import News from '../Component/News'
import Calendar from '../Component/Calender'
import Message from '../Component/Message'
import Campuscare from '../Component/Campuscare'
import OnlineRegistration from '../Component/OnlineRegistration'
// import Facilities from'../Component/Facilities'
import Gallery from '../Component/Gallery'
// import Message from '../Component/Message' 
import Canvas from '../Component/Canvas' 
import Footer from '../Component/Footer'
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload';
const Home = () => {
  return (
    <>
     
      <Campuscare />
      <Popup />
      <Header />

      <OnlineRegistration />
      <HomeSlider/> 
<div className="icon-bar">
     <Link to="https://www.facebook.com/sfxhsr?mibextid=LQQJ4d" className="facebook" target="_blank"><i class="bi bi-facebook"></i></Link>
     <Link to="https://instagram.com/sfxhisar_official?igshid=OGQ5ZDc2ODk2ZA==" className="instagram" target="_blank"><i class="bi bi-instagram"></i></Link>
     <Link to="https://youtube.com/@st.francisxavierschoolhisa9806" className="youtube" target="_blank"><i class="bi bi-youtube"></i></Link>
  </div>
      <div className="aboutmidsec padded-sec">
        <div className='button'>
          <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/pdf/Mandatory-Public-Disclosure.pdf" target="_blank">
            <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/cbse.png" alt="St. Francis Xavier School" /></LazyLoad>
            <p>CBSE   Disclosure</p>
          </Link>
        </div>
        <div className='button'>
          <Link to="https://entab.online/SFXSCH" target='_blank'>
            <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/online.png" alt="St. Francis Xavier School" /></LazyLoad>
            <p>Online Payment</p>
          </Link>
        </div>
        <div className='button'>
          <Link to="https://portalguidelines.campuscare.info/index.html#SFXSCH" target="_blank">
            <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/portal.png" alt="St. Francis Xavier School" /></LazyLoad>
            <p>Portal (Help)?</p></Link>
        </div>
        <div className='phone'>
          <Link to="tel:9588354763">
            <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/contact.png" alt="St. Francis Xavier School" /> </LazyLoad>
          </Link>
        </div>
        <div className='button'>
          <Link to="https://entab.online/SFXSCH" target="_blank">
            <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/alumni.png" alt="St. Francis Xavier School" /></LazyLoad>
            <p>Our Alumni</p>
          </Link>
        </div>
        <div className='button'>
          <Link to="/VirtualTour">
            <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/virtual-tour.png" alt="St. Francis Xavier School" /></LazyLoad>
            <p>Virtual Tour</p>
          </Link>
        </div>
        <div className='button kids-corner'>
          <Link to="/KidsCorner">
            <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/kids-corner.png" alt="St. Francis Xavier School" /></LazyLoad>
            <p>Kids Corner</p>
          </Link>
        </div>
      </div>
      <div className="aboutsec about-bg">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className="col-lg-5"></div>
            <div className="col-lg-7 about-bg">
              <div className="about-news">
                <div className='title'>
                  <h2>Latest News</h2>
                   <Link to="/News" className='read-more'>
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/r_more.gif" className='img-fluid' />
                  </Link>
                </div>
                <News />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='aboutSection'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-lg-6 abt-content-block'>
              <div className='abt-content section-title'>
                <div className='title'>
                  <h2>about us</h2>
                </div>
                <p><b>St. Francis Xavier School, Hisar </b>was established in 1991. It is one of the manyeducational institutions run by the Delhi Province of the Society of the Missionaries of <b> St. Francis Xavier alias Society of Pilar.</b> The Society was founded in Goa way back in 1887. Fr. Bento Martins, an ordinary priest with an extraordinary vision, started this Organization with the aim of spreading Jesus' Gospel of human well being and universal love even beyond the borders of Goa. The school is named after St. Francis Xavier the Apostle of the East, a Jesuit priest of the 15th century, who is also the patron of our missionary society. The Society of Pilar has over <b> three hundred members</b> serving the cause of the Gospel message of justice, freedom and love, in about sixty residential units and institutions spread all over India, and countries abroad.</p>
                <button className='button'><Link to="/AboutUs">Read More <i className="bi bi-arrow-right"></i></Link></button>
              </div>
            </div>
            <div className='col-lg-6'>
              <div className="about-img">
                <div className='d-flex'>
                  <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/about-school1.png' alt="St. Francis Xavier School" /></LazyLoad>
                  <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/about-school2.png' alt="St. Francis Xavier School" /></LazyLoad>

                </div>
                <div className='d-flex'>
                  <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/about-school6.png' alt="St. Francis Xavier School" /></LazyLoad>
                  <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/about-school.png' className='no-anim' alt="St. Francis Xavier School" /></LazyLoad>
                  <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/about-school3.png' alt="St. Francis Xavier School" /></LazyLoad>
                </div>
                <div className='d-flex'>
                  <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/about-school5.png' alt="St. Francis Xavier School" /></LazyLoad>
                  <LazyLoad><img src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/about-school4.png' alt="St. Francis Xavier School" /></LazyLoad>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
      <div className='message padded-sec section-title'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-lg-5'>
            <div className='title'>
                
                <h2>Event Calender</h2>
              </div>
              <Calendar />
            </div>
            <div className='col-lg-1'>
            </div>
            <div className='col-lg-6'>
              <div className='msg-blk'>
              <div className='title'> 
                <h2>Message section</h2>
              </div>
              <Message />
              </div>
            </div>
          </div>
        </div>
      </div>
     
      <div className="event padded-sec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className="col-lg-5 section-title">
              <div className='canvas'>
                <div className='title'> 
                  <h2>Creative canvas</h2>
                </div>
                <div className='canvas-blk'>
                  <Canvas />
                </div>
              </div>
            </div>
            <div className="col-lg-7 section-title event-section">
              <div className='title'> 
                <h2>events updates</h2>
              </div>
              <Events />
            </div> 
          </div>
        </div>
      </div>

      <div className='recent-activity'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='activity_block'>
                <h3>Recent Activities in the School</h3>
                <div>
                  <RecentActivity />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="topper-birthday padded-sec">
        <div className="container-fluid section-title">
          <div className="row">
            <div className="col-lg-7">
              <div className='topper-title'>
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/topper-tag.png" className='main-img img-fluid m-auto d-block' alt='St. Francis Xavier School' />
              </div>
              
              <div className="inline_block">
                <div>
                  <div className='title'>
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/trophy.gif" className='main-img img-fluid m-auto d-block' alt='St. Francis Xavier School' />
                    <h4><b>X </b>toppers</h4>
                  </div>
                  <TopperX />
                </div>
                <div>
                  <div className='title'>
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/trophy.gif" className='main-img img-fluid m-auto d-block' alt='St. Francis Xavier School' />
                    <h4><b>XII</b> toppers</h4>
                  </div>
                  <TopperXII />
                </div>
                </div>
            </div>
            <div className="col-lg-5">
              <div className='birthday-title'>
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/birthday.png" className="img-fluid m-auto d-block" alt="St. Francis Xavier School" />                
              </div>
              <div className='title'>
              
                    <h4><b>Today’s</b> Birthday</h4>
                  </div>
              <Birthday />
            </div>
          </div>
        </div>
      </div>
      <div className="homegallery padded-sec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className='col-md-12 section-title'>
              <div className='title'>
                <h2>Gallery section</h2>
              </div>
            </div>
            <div className="col-lg-12">
              <Gallery />
              {/* <button className='button'><Link to="/gallery">Read More</Link></button> */}
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
            <div className='connect-us'>
              <h3>Discovering knowledge, fostering creativity and inspiring students to pursue their passions</h3>
              <div>
                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/images/call.gif" className='img-fluid' alt="St Francis Xaviers Hisar" />
                <div>
                  <h4>Reach out now</h4>
                  <p>011-25692299</p>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>

  )
}

export default Home
